import React from 'react';
import FontAwesome from 'react-fontawesome';
import { i18n } from '../../../common/services/globalize';
import moment from 'moment';
import { OverlayTrigger, Tooltip, Button } from 'react-bootstrap';

const CalendarToolbar = ({ initialDate }) => toolbar => {
	const goToPrev = () => { toolbar.onNavigate('PREV'); };
	const goToNext = () => { toolbar.onNavigate('NEXT'); };
	const goToToday = () => { toolbar.onNavigate('TODAY'); };

	const date = moment(toolbar.date);
	let label = date.format('ddd, ll');
	let showToday = true, showPrev = true, showNext = true;
	let resourceKeyPrev = 'FO_Booking_Calendar_PrevDay';
	let resourceKeyNext = 'FO_Booking_Calendar_NextDay';

	switch (toolbar.view) {
		case 'week':
			label = `${date.startOf('isoWeek').format('ll')} - ${date.endOf('isoWeek').format('ll')}`;
			resourceKeyPrev = 'FO_Booking_Calendar_PrevWeek';
			resourceKeyNext = 'FO_Booking_Calendar_NextWeek';
			break;
		case 'next7days_week':
			label = `${date.format('ll')} - ${date.add(6, 'days').format('ll')}`;
			showToday = false;
			showPrev = false;
			showNext = false;
			break;
		case 'next7days_day':
			const today = moment(initialDate).startOf('day');
			showToday = false;
			showPrev = date.add(-1, 'days') >= today;
			showNext = date.add(1, 'days') < today.add(6, 'days');
			break;
		case 'day':
		default:
			break;
	}

	return (
		<div className='rbc-toolbar'>
			{showToday && <Button onClick={goToToday}>{i18n.t('Common_Today')}</Button>}
			{showPrev && <OverlayTrigger placement='bottom' overlay={<Tooltip id='prevTooltip'>{i18n.t(resourceKeyPrev)}</Tooltip>}>
				<span onClick={goToPrev} className='btn prev'><FontAwesome name='angle-double-left fa-2x' /> </span>
			</OverlayTrigger>}
			{showNext && <OverlayTrigger placement='bottom' overlay={<Tooltip id='nextTooltip'>{i18n.t(resourceKeyNext)}</Tooltip>}>
				<span onClick={goToNext} className='btn next'><FontAwesome name='angle-double-right fa-2x' /></span>
			</OverlayTrigger>}
			<span className='rbc-toolbar-label'>{label}</span>
		</div>
	);
};

export default CalendarToolbar;